import React from 'react';
import '../../styles/statistics/StatisticsTable.css';
import TableSearch from '../teacherdashboard/TeacherTableSearch';


const StatisticsTable = () => {
    return (
        <div className='statistics-container'><TableSearch/></div>
        
      );
    };
    
export default StatisticsTable;